/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `main` - Główna
 * * `weekend` - Weekendowa
 */
export type QuizQuestionPoolEnum = typeof QuizQuestionPoolEnum[keyof typeof QuizQuestionPoolEnum];


export const QuizQuestionPoolEnum = {
  main: 'main',
  weekend: 'weekend',
} as const;
